export interface RichiestaDocenteIscrizione {
    id?: string;
    nome?: string;
    cognome?: string;
    email?: string;
    plessoName?: string;
    materie?: Array<string>;
    istituto?: string;
}